<section class="flex flex-col">
    <div
        class="container mx-auto max-w-[1280px] flex flex-col h-full md:px-4 px-0 py-0 overflow-hidden select-none md:py-[60px] gap-3 md:gap-6"
    >
        <section class="flex flex-col-reverse md:gap-6 md:items-center md:flex-row">
            <app-my-page-side-bar class="self-start flex-1 w-full" />
            <div class="lg:flex-[5] flex-[3] w-full">
                <router-outlet />
            </div>
        </section>
    </div>
</section>
